import useFetchRefactored from 'civic-champs-shared/api/hooks/useFetchRefactored'
import { useCallback } from 'react'
import fileDownload from 'js-file-download'
import * as moment from 'moment'

import { DEFAULT_TIME_ZONE } from 'civic-champs-shared/utils/format'
import { useCurrentOrg } from 'auth/hooks'

const formatFileName = (name, organization, separator = '_') => {
  const today = moment()
    .tz(organization.timeZone || DEFAULT_TIME_ZONE)
    .format(`DDMMMYYYY${separator}HH:mm`)
  return `${name.replace(/\s/g, separator)}${separator}Responses${separator}${today}.csv`
}

export const useDownloadEventQuestionnaireExport = () => {
  const organization = useCurrentOrg()
  const [request, status] = useFetchRefactored({
    successMessage: 'Export completed',
    errorMessage: 'Error exporting questionnaire',
  })

  const downloadEventQuestionnaireExport = useCallback(
    ({ encodedOccurrence, questionSetId, name, isQuestionnaireAsSurveyEnabled }) => {
      const resource = isQuestionnaireAsSurveyEnabled ? 'surveys' : 'question-sets'
      return request({
        method: 'post',
        url: `opportunity_instances/${encodedOccurrence}/${resource}/${questionSetId}/export`,
        config: {
          responseType: 'blob',
        },
      }).then(blob => fileDownload(blob, formatFileName(name, organization)))
    },
    [organization, request],
  )

  return [downloadEventQuestionnaireExport, status]
}

export default useDownloadEventQuestionnaireExport
